// extracted by mini-css-extract-plugin
export default {"wrap":"StoragePage_wrap__zg+qr"};